import { render, staticRenderFns } from "./AdsPerformance.vue?vue&type=template&id=189ffc3e&scoped=true&"
import script from "./AdsPerformance.vue?vue&type=script&lang=js&"
export * from "./AdsPerformance.vue?vue&type=script&lang=js&"
import style0 from "./AdsPerformance.vue?vue&type=style&index=0&id=189ffc3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ffc3e",
  null
  
)

export default component.exports